import React from "react";
import {
  Box,
  Typography,
  Paper,
  alpha,
  useTheme,
} from "@mui/material";
import { Work as WorkIcon } from "@mui/icons-material";
import CustomSelect from "../FormFields/CustomSelect/CustomSelect";
import {
  jobTitleOptions,
  RBACOptions,
  workAreaOptions,
} from "./CandidateForm.Config";

const CandidateRoleForm = ({ handleChange, formData }) => {
  const theme = useTheme();

  const rbacOptions = RBACOptions.map((item) => ({
    value: String(item.value),
    label: item.name || String(item.value),
  }));

  const jobTitleOptionsFormatted = jobTitleOptions.map((item) => ({
    value: String(item.value),
    label: item.name || String(item.value),
  }));

  const workAreaOptionsFormatted = workAreaOptions.map((item) => ({
    value: String(item.value),
    label: item.name || String(item.value),
  }));

  return (
    <Paper
      elevation={0}
      sx={{
        height: "100%",
        borderRadius: 2,
        border: "1px solid #E2E8F0",
        bgcolor: "#FFFFFF",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          px: 2.5,
          py: 1.5,
          bgcolor: "#F8FAFC",
          borderBottom: "1px solid #E2E8F0",
          display: "flex",
          alignItems: "center",
          gap: 1.5,
        }}
      >
        <Box
          sx={{
            width: 32,
            height: 32,
            borderRadius: "8px",
            bgcolor: alpha(theme.palette.primary.main, 0.08),
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <WorkIcon sx={{ color: theme.palette.primary.main, fontSize: 18 }} />
        </Box>
        <Typography variant="subtitle2" fontWeight={600} color="#1A1A2E">
          Role & Work Area
        </Typography>
      </Box>

      <Box sx={{ p: 2.5 }}>
        <CustomSelect
          options={rbacOptions}
          label="RBAC Role"
          name="rbac_role"
          onChange={handleChange}
          value={formData?.rbac_role !== undefined && formData?.rbac_role !== null ? String(formData.rbac_role) : ""}
          placeholder="Select RBAC Role"
          fullWidth
          size="small"
          searchable
        />

        <Box sx={{ mt: 2 }}>
          <CustomSelect
            options={jobTitleOptionsFormatted}
            label="Job Title"
            name="job_title"
            onChange={handleChange}
            value={formData?.job_title ? String(formData.job_title) : ""}
            placeholder="Select Job Title"
            fullWidth
            size="small"
            searchable
          />
        </Box>

        <Box sx={{ mt: 2 }}>
          <CustomSelect
            options={workAreaOptionsFormatted}
            label="Work Area"
            name="work_area"
            onChange={handleChange}
            value={formData?.work_area ? String(formData.work_area) : ""}
            placeholder="Select Work Area"
            fullWidth
            size="small"
          />
        </Box>
      </Box>
    </Paper>
  );
};

export default CandidateRoleForm;